<template>
  <div class="bso-reports__docs">
    <h6 class="mt-0">{{ $t('Документы') }}</h6>
    <v-dialog v-model="dialog" max-width="500">
      <v-card class="modal license-payment-modal">
        <div class="modal-head">
          <template v-if="currentDocument.id">
            {{ $t('Редактирование') }}
          </template>
          <template v-else>
            {{ $t('Добавление') }}
          </template>
          <v-btn color="modal-close" @click="resetDocument(false)">
            <img src="@/assets/img/close-icon.png" alt="icon">
          </v-btn>
        </div>
        <div class="modal-body">
          <v-form
            ref="form"
            enctype="multipart/form-data"
            @submit.prevent="changeDocument"
          >
            <v-row :class="{ invalid: $v.currentDocument.fileType.$error }">
              <v-col cols="4" md="4" class="input-label">
                <v-label>{{ $t('Тип') }}: <span class="asterix">*</span></v-label>
                <fieldInfo :info="$t('Тип')"/>
              </v-col>
              <v-col class="input-field">
                <div class="select-def">
                  <v-select
                    :items="types"
                    item-value="id"
                    item-text="transName"
                    v-model="currentDocument.fileType"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </v-col>
            </v-row>
            <v-row :class="{ invalid: $v.currentDocument.file.$error }">
              <v-col cols="4" md="4" class="input-label">
                <v-label>
                  {{ $t('Файл') }}: <span class="asterix">*</span>
                  <fieldInfo :info="$t('Файл')"/>
                </v-label>
              </v-col>
              <v-col class="input-field">
                <a v-if="currentDocument.fullFilePath" :href="backUrl + currentDocument.fullFilePath" target="_blank">{{ $t('Файл') }}</a>
                <v-file-input
                  dense
                  clearable
                  ref="file"
                  v-model="currentDocument.file"
                  v-on:change="handleFileUpload()"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="4" class="input-label">
                <v-label>{{ $t('Описание') }}:</v-label>
                <fieldInfo :info="$t('Описание')"/>
              </v-col>
              <v-col class="input-field">
                <v-textarea
                  v-model="currentDocument.description"
                  outlined
                  dense
                  class="size-small"
                />
              </v-col>
            </v-row>
            <div class="form-action">
              <button
                class="btn btn-default blue"
                type="submit"
              >
                {{ $t('Сохранить') }}
              </button>
              <button
                class="btn btn-default gray"
                type="button"
                @click="resetDocument(false)"
              >
                {{ $t('Отмена') }}
              </button>
            </div>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
    <div v-if="documents.length > 0" class="table-overflow">
      <table>
        <thead>
        <tr>
          <td>{{ $t('Файл') }}</td>
          <td>{{ $t('Описание') }}</td>
          <td v-if="editable" class="td-action">{{ $t('Действия') }}</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(document, index) in documents" :key="index">
          <td>
            <div v-if="document.fullFilePath">
              <template v-if="checkFileExist(document.fileExtension)">
                <a
                  @click="previewDocumentDialog(document.id, true)"
                >{{ document.fileTypeName }}</a>
                <v-dialog
                  v-model="previewDocsModal[document.id]"
                  max-width="1200"
                >
                  <v-card class="modal">
                    <div class="modal-head">
                      {{ document.fileTypeName }}
                      <v-btn
                        color="modal-close"
                        @click="previewDocumentDialog(document.id, false)"
                      >
                        <img src="@/assets/img/close-icon.png" alt="icon">
                      </v-btn>
                    </div>
                    <div class="modal-body">
                      <VueDocPreview
                        :value="backUrl + document.fullFilePath"
                        type="office"
                      />
                    </div>
                  </v-card>
                </v-dialog>
              </template>
              <template v-else>
                <a
                  :href="backUrl + document.fullFilePath"
                  target="_blank"
                >{{ document.fileTypeName }}</a>
              </template>
            </div>
          </td>
          <td>{{ document.description }}</td>
          <td class="td-action" v-if="editable">
            <v-btn class="btn-add" @click.native.stop="fetchData(document.id)">
              <span class="edit-icon"></span>
            </v-btn>
            <v-btn class="btn-add btn-delete" @click.native.stop="deleteDocument(document.id)">
              <v-icon>delete_forever</v-icon>
            </v-btn>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="form-group">
      <v-btn v-if="editable" class="btn-add btn-add-small" @click.native.stop="fetchData(null)">
        <img src="@/assets/img/plus-icon.png" alt="icon">
        {{ $t('Добавить документ') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import fieldInfo from '@/components/app/fieldInfo'
import VueDocPreview from 'vue-doc-preview'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'
import PermitReport from '@/model/permitReport'

export default {
  components: {
    fieldInfo,
    VueDocPreview
  },
  props: {
    documents: Array,
    editable: Boolean,
    bsoId: Number|String
  },
  data: () => ({
    backUrl: process.env.VUE_APP_BACK_URL,
    previewDocsModal: [],
    dialog: false,
    currentDocument: {},
    types: [],
    rules: {
      currentDocument: {
        fileType: { required },
        file: {
          required: requiredIf(
            function () {
              return !this.currentDocument.fullFilePath
            })
        }
      }
    }
  }),
  computed: {
    listLocal: {
      get () {
        return this.documents
      },
      set (newList) {
        this.$emit('update:documents', newList)
      }
    }
  },
  validations () {
    return this.rules
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData (id) {
      PermitReport.getDocumentFormData()
        .then((response) => {
          this.types = response.data.refPermitReportFileTypes
        })
        .catch((error) => {
          console.log(error)
        })
      if (id) {
        PermitReport.showDocument(id)
          .then((response) => {
            this.currentDocument = response.data.document
            this.dialog = true
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        this.currentDocument = {
          description: '',
          type: null,
          file: null
        }
        this.$v.$reset()
        this.dialog = true
      }
    },
    // Создание/редактирование
    changeDocument () {
      if (!this.validateForm()) {
        return
      }
      const formData = new FormData()
      if (this.currentDocument.file) {
        formData.append('fauna_license_application_bso_document[uploadedFile]', this.currentDocument.file)
      }
      if (this.currentDocument.description) {
        formData.append('fauna_license_application_bso_document[description]', this.currentDocument.description)
      }
      formData.append('fauna_license_application_bso_document[fileType]', this.currentDocument.fileType)
      let params = {
        id: this.bsoId,
        route: 'createFaunaLicenseApplicationBsoDocument'
      }
      if (this.currentDocument.id) {
        params = {
          id: this.currentDocument.id,
          route: 'editFaunaLicenseApplicationBsoDocument'
        }
      }

      PermitReport.updateDocument(params, formData).then((response) => {
        if (response.status === 201 || response.status === 202) {
          this.$noty.success(response.status === 202 ? this.$i18n.t('Успешно обновлено') : this.$i18n.t('Успешно добавлено'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
          this.listLocal = response.data.documents
          this.dialog = false
        }
      })
        .catch((error) => {
          let msg = error.message
          if (error.response) {
            if (error.response.data.form) {
              msg = this.$i18n.t(error.response.data.form.message)
            } else if (error.response.data.message) {
              msg = this.$i18n.t(error.response.data.message)
            }
          }
          this.validateForm()
          this.$noty.error(msg, {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })
    },
    // удаляем документ
    deleteDocument (id) {
      if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
        this.setLoading(true)
        PermitReport.deleteDocument(id)
          .then((response) => {
            this.listLocal = response.data.documents
            this.setLoading(false)
          })
          .catch((error) => {
            console.log(error)
            this.setLoading(false)
          })
      }
    },
    handleFileUpload () {
      if (this.currentDocument.file) {
        this.createFile(this.currentDocument.file)
      }
    },
    createFile (file) {
      const reader = new FileReader()
      const vm = this

      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    // Обновление формы для добавления
    resetDocument (flag) {
      this.dialog = flag
      this.currentDocument = {}
      this.$v.$reset()
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // предпросмотр файлов
    previewDocumentDialog (id, flag) {
      this.$set(this.previewDocsModal, id, flag)
    },
    checkFileExist (ext) {
      const fileExtensions = ['doc', 'docx', 'xls', 'xlsx']
      const exist = fileExtensions.some(function (field) {
        return field === ext
      })
      return exist
    }
  }
}
</script>

<style scoped>

</style>
